import palette from '../palette';

export default {
  styleOverrides: {
    colorPrimary: {
      color: palette.primary.main,
    },
  },
};
